import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class UniversitySortOption extends BaseModel {
  static override constructorName = 'UniversitySortOption'

  id: number | string = 0
  name: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(UniversitySortOption)
